import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Checkbox,
  tableCellClasses,
  CircularProgress,
  InputLabel,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TableCell,
  Select,
  MenuItem,
  ListItemText,
  InputAdornment,
  Divider,
} from "@mui/material";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { CheckIcon, FontFamily, PendingIcon, SearchIcon } from "assets";
import { makeStyles } from "@mui/styles";
import styled from "@emotion/styled";
import InputField from "components/Input";
import { useForm } from "react-hook-form";
import { ErrorToaster } from "components/Toaster";
import moment from "moment";
import ClientServices from "services/Client";
import { useAuth } from "context/UseContext";
import FinanceServices from "services/Finance";
import { SuccessToaster } from "components/Toaster";
import { useNavigate } from "react-router-dom";
import CurrencyServices from "services/Currency";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import BankServices from "services/Bank";
import DatePicker from "components/DatePicker";
import { allowedRolesForCash, CommaSeparator, findDifferences } from "utils";
import Pagination from "components/Pagination";
import CostingDialog from "components/Dialog/CostingDialog";
import ExportShippingInvoiceV2 from "components/erp_invoices/shipping_invoices_v2";
import SystemServices from "services/System";
import { createRoot } from "react-dom/client";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "normal",
    verticalAlign: "top",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    verticalAlign: "middle",
    // whiteSpace: "normal",
    // wordBreak: "break-word",
    padding: "3px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "3px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "5px",
      width: "24px",
      height: "24px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function ClientFundsApplicationV2() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const { usdExchangeRate, cadExchangeRate } = useSelector(
    (state) => state.navigationReducer,
  );

  // *For Total Amount
  const [totalAmount, setTotalAmount] = useState([]);

  const [allSums, setAllSums] = useState();

  // *For Client Dropdown
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [costingDialogOpen, setCostingDialogOpen] = useState(false);
  const [savedData, setSavedData] = useState({});

  // *for Payment Type

  const [paymentType, setPaymentType] = useState("aed");

  // *For Cashier Account
  const [cashierAccounts, setCashierAccounts] = useState([]);
  const [selectedCashierAccount, setSelectedCashierAccount] = useState(null);
  const [selectedVehicles, setSelectedVehicles] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const [clientCosting, setClientCosting] = useState([]);
  const [copyClientCosting, setCopyClientCosting] = useState();
  const [selectedClientBooking, setSelectedClientBooking] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState(null);

  const [vaultAccounts, setVaultAccounts] = useState([]);

  // *Cashier Details
  const [cashierDetails, setCashierDetails] = useState(false);

  // *For Vin and Lot
  const [vin, setVin] = useState();
  const [selectedVin, setSelectedVin] = useState();
  const [lot, setLot] = useState();
  const [selectedLot, setSelectedLot] = useState();

  // *For Filters
  const [filters, setFilters] = useState({});

  const [showTotal, setShowTotal] = useState(false);

  const [walletBalance, setWalletBalance] = useState();

  const [totalPayment, setTotalPayment] = useState();

  // *wallet Id
  const [walletId, setWalletId] = useState();
  const [selectAll, setSelectAll] = useState(false);

  // *For Currencies
  const [currencyExchangeRate, setCurrencyExchangeRate] = useState();

  // *for button Disable
  const [buttonState, setButtonState] = useState(false);

  // loss
  const [loss, setLoss] = useState(0);
  const [items, setItems] = useState([]);
  const [balances, setBalances] = useState({});
  // *for details
  const [sendDetails, setSendDetails] = useState();

  // *For Bank Account
  const [bankAccounts, setBankAccounts] = useState([]);
  const [bankAccountsGuc, setBankAccountsGuc] = useState([]);
  const [bankAccountsGws, setBankAccountsGws] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedVaultAccount, setSelectedVaultAccount] = useState(null);
  const [aedTotalAmount, setAedTotalAmount] = useState(0);
  const [exchangeLoss, setExchangeLoss] = useState(0);
  const [customerId, setCustomerId] = useState(null);
  const [date, setDate] = useState(new Date());
  const [searchTerm, setSearchTerm] = useState("");
  const classes = useStyles();
  const [lastSelectedItemId, setLastSelectedItemId] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(true);
  const [receiveShippingMap, setReceiveShippingMap] = useState({});
  const [receiveCustomMap, setReceiveCustomMap] = useState({});
  const [receiveVatMap, setReceiveVatMap] = useState({});

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    setValue,
    getValues: getValues2,
    formState: { errors: errors2 },
    reset,
  } = useForm();

  const tableHead = [
    "SELECT",
    "CUSTOMER",
    "INV. REF",
    "PURCHASED",
    "MAKE/MODEL/COLOR",
    "LOT",
    "VIN",
    "ARR.PORT",
    // 'STORAGE $',
    // 'LATE FEE $',
    "TOTAL COSTING $",
    // 'DISC $',
    "CUSTOM $",
    "VAT $",
    // 'PAID C+V $',
    "TOTAL SHIPPING DUE $",
    "SHIPPING AMOUNT",
    "CUSTOM AMOUNT",
    "VAT AMOUNT",
    "PAID",
    "BALANCE",
    "STATUS",
    // 'CATEGORY A',
    // 'BROKER FEE',
    // 'TITLE FEE',
    // 'Attestation/SUV Fee',
    // 'TOTAL SHIPPING',

    // 'Discount',
    // 'Receiving Amount',

    // 'Action',
  ];

  const [visibleColumns, setVisibleColumns] = useState([
    ...Array(tableHead.length).keys(),
  ]);

  // useEffect(() => {
  //   getBanks();
  // }, []);
  const handleColumnChange = (event) => {
    const selectedColumns = event.target.value;
    // Sort the selected columns to maintain the correct order
    const sortedColumns = selectedColumns.sort((a, b) => a - b);
    setVisibleColumns(sortedColumns);
  };

  // *For Clients
  const getClientDropdown = async () => {
    try {
      const { data } = await ClientServices.getClientDropdown();
      setClients(data?.customers?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleAppliedAmountChange = () => {
    handleCalc2();

    // if (walletBalance < getValues2('appliedAmountWallet')) {
    //   setValue('appliedAmountWallet', 0);
    // }
    if (isNaN(parseFloat(getValues2("appliedAmountCashier")))) {
      setValue("appliedAmountCashier", "");
    }
    if (isNaN(parseFloat(getValues2("appliedAmountWallet")))) {
      setValue("appliedAmountWallet", "");
    }
    if (isNaN(parseFloat(getValues2("appliedAmountBank")))) {
      setValue("appliedAmountBank", "");
    }

    let sum =
      parseFloat(getValues2("appliedAmountCashier")) +
      parseFloat(getValues2("appliedAmountWallet")) +
      parseFloat(getValues2("appliedAmountBank"));
    if (parseFloat(sum).toFixed(2) == totalPayment) {
      setButtonState(true);
    } else {
      setButtonState(false);
    }
  };
  // *For Get Banks
  const getBanks = async () => {
    try {
      let params = {
        page: 1,
        limit: 500,
        allow_active_only: 0,
      };
      const { data } = await BankServices.getBanks(params);
      const bankArray = [];
      data?.banks?.rows
        .filter((e) => e.currency)
        .forEach((e) => {
          let obj = {
            ...e,
            account_code: e?.guc_account?.account_code,
            name: e?.guc_account?.name,
          };
          bankArray.push(obj);
        });
      const gwsBank = bankArray.filter((bank) => bank?.gwc_account !== null);
      const gucBank = bankArray.filter((bank) => bank?.guc_account !== null);
      setBankAccountsGws(gwsBank);
      setBankAccountsGuc(gucBank);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // *For Vin Lot
  const getVin = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await ClientServices.getTTVin(params);
      const arrayOfObjects = data?.details?.vins.map((value, index) => ({
        id: value?.vin, // Adding 1 to start the id from 1
        name: value?.vin,
      }));
      const arrayOfObjects1 = data?.details?.lots.map((value, index) => ({
        id: value?.lot, // Adding 1 to start the id from 1
        name: value?.lot,
      }));

      setVin(arrayOfObjects);
      setLot(arrayOfObjects1);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Currencies
  const getCurrencies = async (currency) => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await CurrencyServices.getCurrencies(params);

      setCurrencyExchangeRate(data.currencies[2].conversion_rate);
      setValue("exChangeRate", data.currencies[2].conversion_rate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Vault Customers
  const getVaultCustomers = async (id) => {
    try {
      const cid =
        selectedClient?.id ||
        clientCosting?.[0]?.booking?.customer?.id ||
        clientCosting?.[0]?.booking?.customer_id;
      if (!cid) {
        setVaultAccounts([]);
        return;
      }
      let params = {
        page: 1,
        limit: 50,
        customer_id: cid,
        type: "Shipping",
      };
      const { data } = await FinanceServices.getVaultCustomers(params);
      let findAccount = data?.customers?.rows[0].accounts.find(
        (account) =>
          account.type_code === "L2" && account.primary_series === 50005,
      );
      const filterData = data?.customers?.rows
        ?.find((customer) => customer?.id === cid)
        ?.accounts?.filter((account) => account.unit === "Shipping");

      setVaultAccounts(Array.isArray(filterData) ? filterData : []);
      // setVaultAccounts(filterData);

      setWalletBalance(findAccount?.total_cr - findAccount?.total_dr);
      // setWalletId(data?.customers?.rows[0].accounts[0].id);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Handle Select Vault Detail
  const handleSelectVault = (data) => {
    setSelectedVaultAccount(data);
    const debit = data?.total_dr ? data?.total_dr : 0;
    const credit = data?.total_cr ? data?.total_cr : 0;
    const balance =
      data?.nature === "credit"
        ? parseFloat(credit) - parseFloat(debit)
        : parseFloat(debit) - parseFloat(credit);
    setValue("vaultBalance", parseFloat(balance / 3.675).toFixed(2));
    setWalletBalance(balance);
  };
  // *For Get Payment Accounts
  const getPaymentAccounts = async () => {
    try {
      let params = {
        page: 1,
        limit: 1000,
      };
      const { data } = await FinanceServices.getShippingPaymentAccounts(params);
      // *Filter only vehicle account
      const vehicleAcc = data?.cashierAccounts?.rows?.filter(
        (e) => e.unit === "Shipping" && e.currency === "aed",
      );

      setBankAccounts(data?.bankAccounts?.rows);
      // *1003 is the cashier role ID if the login user is a cashier then show only their account
      if (allowedRolesForCash.includes(user?.role_id)) {
        const userId = user?.ref_id.split("-")[1];
        const filterCashier = vehicleAcc.filter((e) => e.user_id == userId);
        setCashierAccounts(filterCashier);
        // *Select Default AED cashier account
        const cashierDetail = filterCashier.find(
          (e) => e.currency === paymentType,
        );
        setValue("cash", cashierDetail?.name);
        setSelectedCashierAccount(cashierDetail);
      } else {
        setCashierAccounts(vehicleAcc);
        // *Select Default AED cashier account
        const cashierDetail = vehicleAcc.find(
          (e) => e.currency === paymentType,
        );
        setValue("cash", cashierDetail?.name);
        setSelectedCashierAccount(cashierDetail);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const [receiveAmounts, setReceiveAmounts] = useState({
    shipping: 0,
    custom: 0,
    vat: 0,
  });

  const [receiveShipping, setReceiveShipping] = useState("");
  const [receiveCustom, setReceiveCustom] = useState("");
  const [receiveVat, setReceiveVat] = useState("");
  const [defaultCustomDue, setDefaultCustomDue] = useState({});
  const [defaultShipping, setDefaultShipping] = useState({});
  const [defaultVatDue, setDefaultVatDue] = useState({});

  const handleReceiveChange = (field, value) => {
    const val = parseFloat(value) || 0;
    setReceiveAmounts((prev) => ({
      ...prev,
      [field]: val,
    }));
  };
  const [balances1, setBalances1] = useState([]);

  const handleCalc = (fieldName, id, currency, val, item) => {
    let sendBalance;

    // Set the last selected item ID
    setLastSelectedItemId(id);

    if (val > 0) {
      setCashierDetails(true);
    } else {
      setCashierDetails(false);
    }

    if (fieldName === "discount") {
      const discountValue = parseFloat(val) || 0;
      const newBalance =
        parseFloat(
          item?.invoice.shipping_total -
            parseFloat(item?.invoice.shipping_paid),
        ) - discountValue;
      const newBalanceRemaining =
        parseFloat(item?.invoice.balance) - discountValue;

      const updatedBalanceObj = { id: id, balance: newBalance };
      const updatedBalancesArray = [...balances1, updatedBalanceObj];
      setBalances1(updatedBalancesArray);

      function filterUniqueById(arr) {
        const uniqueObjects = {};
        arr.forEach((obj) => {
          uniqueObjects[obj.id] = obj;
        });
        return Object.values(uniqueObjects);
      }

      const resultArray = filterUniqueById(updatedBalancesArray);
      sendBalance = resultArray;

      setBalances((prevBalances) => ({
        ...prevBalances,
        [id]: parseFloat(newBalance).toFixed(2),
      }));

      // if (id === lastSelectedItemId) {
      //   const isButtonEnabled =
      //     parseFloat(newBalanceRemaining) >= 1 || parseFloat(newBalanceRemaining) === 0;
      //   setButtonEnabled(isButtonEnabled);
      // }
    }

    try {
      const shallowCopy = [...totalAmount];
      const index = totalAmount.findIndex((e) => e.id === id);

      let usd = Number.isNaN(parseFloat(val)) ? 0 : parseFloat(val);
      if (fieldName === "discount") {
        usd = -usd;
      }

      shallowCopy[index][fieldName] = usd;

      let total = 0;
      for (let key in shallowCopy[index]) {
        if (key !== "id" && key !== "discount") {
          total += parseFloat(shallowCopy[index][key]);
        }
      }
      shallowCopy[index].amount = parseFloat(total).toFixed(2);
      setTotalAmount(shallowCopy);

      const updatedSendDetails = sendDetails.map((item) => {
        if (item.id === id) {
          item.applied_amount = val;
        }
        return item;
      });

      const updatedDetails = updatedSendDetails.map((detail) => {
        const matchingDiscount = sendBalance.find(
          (balance) => balance.id === detail.id,
        );
        if (matchingDiscount) {
          return {
            ...detail,
            invoice: {
              ...detail.invoice,
              balance: matchingDiscount.balance,
            },
          };
        }
        return detail;
      });

      setSendDetails(updatedDetails);

      const subAmount = shallowCopy.reduce((sum, item) => {
        if (selectedClientBooking.includes(item.id)) {
          const discount = Number.isNaN(parseFloat(item?.discount))
            ? 0
            : parseFloat(item?.discount);
          return sum + (discount !== 0 ? discount : 0);
        }
        return sum;
      }, 0);

      const absoluteSubAmount = Math.abs(subAmount);
      setTotalPayment(absoluteSubAmount);
      setShowTotal(true);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Handle Date
  const handleFromDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setDate(new Date());
        return;
      }
      setDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Handle Filter
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    if (value !== "") {
      setSearchTerm(value);

      // Filter the original data based on the search term
      const filteredData = clientCosting?.filter((item) => {
        const vin = item?.booking?.vin ? item?.booking?.vin.toLowerCase() : "";
        const lot_number = item?.booking?.lot_number
          ? item?.booking?.lot_number.toLowerCase()
          : "";
        return vin.includes(value) || lot_number.includes(value);
      });

      setClientCosting(filteredData);
    } else {
      setClientCosting(copyClientCosting); // Reset to original data
    }
  };
  // const addItem = (item) => {
  //   setItems([item, ...items]);

  //   setSendDetails([item, ...items]);
  // };

  const recalculateTotal = (selectedIds) => {
    try {
      const subAmount = totalAmount.reduce((sum, item) => {
        if (selectedIds.includes(item.id)) {
          const discount = Number.isNaN(parseFloat(item?.discount))
            ? 0
            : parseFloat(item?.discount);
          return sum + (discount !== 0 ? discount : 0);
        }
        return sum;
      }, 0);

      const absoluteSubAmount = Math.abs(subAmount);
      setTotalPayment(absoluteSubAmount);
      setShowTotal(true);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const recalculateSelectedSums = () => {
    let totalShipping = 0;
    let totalCustom = 0;
    let totalVAT = 0;
    let totalPaid = 0;
    let totalBalance = 0;
    let totalCosting = 0;

    selectedClientBooking.forEach((id) => {
      const item = clientCosting.find((x) => x.id === id);
      if (!item || !item.invoice) return;

      const shippingTotal = parseFloat(item.invoice.shipping_total || 0);
      const shippingPaid = item?.invoice?.payment?.reduce(
        (sum, p) => sum + (parseFloat(p?.shipping_amount) || 0),
        0,
      );
      const customTotal = parseFloat(item.invoice.custom_total || 0);
      const customPaid =
        item.invoice.payment?.reduce(
          (sum, p) => sum + (parseFloat(p.custom_amount) || 0),
          0,
        ) || 0;
      const vatTotal = parseFloat(item.invoice.vat_total || 0);
      const vatPaid =
        item.invoice.payment?.reduce(
          (sum, p) => sum + (parseFloat(p.vat_amount) || 0),
          0,
        ) || 0;

      totalCosting += Math.max(shippingTotal - shippingPaid, 0);

      if (item?.vehicle?.vcc?.custom_due) {
        totalCustom += Math.max(customTotal - customPaid, 0);
      }

      if (item?.vehicle?.vcc?.vat_due) {
        totalVAT += Math.max(vatTotal - vatPaid, 0);
      }
      totalShipping += Math.max(
        shippingTotal -
          shippingPaid +
          customTotal -
          customPaid +
          vatTotal -
          vatPaid,
        0,
      );

      totalPaid += shippingPaid;
      totalBalance += shippingTotal - shippingPaid;
    });

    setAllSums([
      { value: totalCosting || 0, flag: true },
      { value: totalCustom || 0, flag: true },
      { value: totalVAT || 0, flag: true },
      { value: totalShipping || 0, flag: true },
    ]);
  };

  useEffect(() => {
    if (selectedClientBooking.length > 0) {
      recalculateSelectedSums();
      recalculateTotal(selectedClientBooking);
    } else {
      setAllSums([]);
      setTotalPayment(0);
    }
  }, [selectedClientBooking]);

  const handleSelectClientBooking = (item, id) => {
    try {
      const selectedCustomerId =
        item?.booking?.customer_id || item?.booking?.customer?.id;

      // If this is the first selection, initialize customerId and proceed
      if (!customerId) {
        setCustomerId(selectedCustomerId);
        getVaultCustomers(selectedCustomerId);
      }

      // If customerId is already set and it doesn't match the new selection, show an error
      if (customerId && customerId !== selectedCustomerId) {
        ErrorToaster("You cannot select Vehicle for different customers.");
        return;
      }

      const shallowCopy = [...selectedClientBooking];
      const currentIndex = shallowCopy.indexOf(id);

      if (currentIndex === -1) {
        // Add the new booking to the list
        shallowCopy.push(id);
        const updatedItem = { ...item, applied_amount: 0 };
        addItem(updatedItem);

        const totalShip = parseFloat(item?.invoice?.shipping_total || 0);
        const paidShip = item?.invoice?.payment?.reduce(
          (sum, p) => sum + (parseFloat(p?.shipping_amount) || 0),
          0,
        );
        const ShipDue = Math.max(totalShip - paidShip, 0);

        setReceiveShippingMap((prev) => ({
          ...prev,
          [id]: parseFloat(ShipDue).toFixed(2),
        }));
        setDefaultShipping((prev) => ({
          ...prev,
          [id]: parseFloat(ShipDue).toFixed(2),
        }));

        const totalVat = parseFloat(item?.invoice?.vat_total || 0);
        const paidVat = item?.invoice?.payment?.reduce(
          (sum, p) => sum + (parseFloat(p?.vat_amount) || 0),
          0,
        );
        const vatDue = Math.max(totalVat - paidVat, 0);
        setReceiveVatMap((prev) => ({
          ...prev,
          [id]: parseFloat(vatDue).toFixed(2),
        }));
        setDefaultVatDue((prev) => ({
          ...prev,
          [id]: parseFloat(vatDue).toFixed(2),
        }));

        const totalCustom = parseFloat(item?.invoice?.custom_total || 0);
        const paidCustom = item?.invoice?.payment?.reduce(
          (sum, p) => sum + (parseFloat(p?.custom_amount) || 0),
          0,
        );
        const customDue = Math.max(totalCustom - paidCustom, 0);
        setReceiveCustomMap((prev) => ({
          ...prev,
          [id]: parseFloat(customDue).toFixed(2),
        }));
        setDefaultCustomDue((prev) => ({
          ...prev,
          [id]: parseFloat(customDue).toFixed(2),
        }));
      } else {
        // Remove the existing booking from the list
        shallowCopy.splice(currentIndex, 1);
        removeItem(id);

        setReceiveShippingMap((prev) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });

        setReceiveVatMap((prev) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });

        setReceiveCustomMap((prev) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });

        // If no bookings are left, reset the customerId
        if (shallowCopy.length === 0) {
          setCustomerId(null);
        }
      }

      setSelectedClientBooking(shallowCopy);
      recalculateSelectedSums();

      recalculateTotal(shallowCopy);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // const handleSelectClientBooking = (item, id) => {
  //   try {
  //     const isSelected = selectedCheckboxes.includes(id); // Check if the item is already selected
  //     const newSelectedCheckboxes = isSelected
  //       ? selectedCheckboxes.filter((checkboxId) => checkboxId !== id) // If selected, remove it
  //       : [...selectedCheckboxes, id]; // If not selected, add it to the list

  //     setSelectedCheckboxes(newSelectedCheckboxes); // Update the state with the new list of selected checkboxes

  //     // Optionally handle the booking or other data changes here
  //     recalculateTotal(newSelectedCheckboxes); // Recalculate total or any other necessary updates
  //   } catch (error) {
  //     ErrorToaster(error);
  //   }
  // };

  // const handleAllCheck = (value) => {
  //   setSelectAll(value); // Set whether "Select All" is checked or unchecked
  //   if (value) {
  //     const allBookingIds = clientCosting?.map((data) => data?.id); // Get all client booking IDs
  //     setSelectedCheckboxes(allBookingIds); // Select all checkboxes
  //     recalculateTotal(allBookingIds); // Recalculate total or any other necessary updates
  //   } else {
  //     setSelectedCheckboxes([]); // Deselect all checkboxes
  //     recalculateTotal([]); // Reset the total or other calculations
  //   }
  // };

  const handleAllCheck = (value) => {
    setSelectAll(value);
    try {
      if (value) {
        // Select all client bookings
        const allBookingIds = clientCosting?.map((data) => data?.id);
        setSelectedClientBooking(allBookingIds);

        const allItemsWithDefaults = clientCosting.map((data) => ({
          ...data,
          applied_amount: 0,
        }));

        allItemsWithDefaults.forEach((item) => addItem(item));
        recalculateTotal(allBookingIds);
      } else {
        // Deselect all client bookings
        const allBookingIds = selectedClientBooking;
        setSelectedClientBooking([]);
        recalculateSelectedSums();

        allBookingIds.forEach((id) => removeItem(id));
        recalculateTotal([]);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // Function to remove the unchecked vehicle's data
  const addItem = (item) => {
    setItems((prevItems) =>
      Array.isArray(prevItems) ? [item, ...prevItems] : [item],
    );
    setSendDetails((prevDetails) =>
      Array.isArray(prevDetails) ? [item, ...prevDetails] : [item],
    );

    setTotalAmount((prevAmounts) => {
      if (!Array.isArray(prevAmounts)) prevAmounts = [];
      if (!prevAmounts.find((amount) => amount.id === item.id)) {
        return [{ id: item.id, amount: 0, discount: 0 }, ...prevAmounts];
      }
      return prevAmounts;
    });
  };

  // Remove the unchecked vehicle's data
  const removeItem = (id) => {
    setItems((prevItems) =>
      Array.isArray(prevItems)
        ? prevItems.filter((item) => item.id !== id)
        : [],
    );
    setSendDetails((prevDetails) =>
      Array.isArray(prevDetails)
        ? prevDetails.filter((detail) => detail.id !== id)
        : [],
    );
    setTotalAmount((prevAmounts) =>
      Array.isArray(prevAmounts)
        ? prevAmounts.filter((amount) => amount.id !== id)
        : [],
    );
  };
  // *For Client Costing

  const getClientCosting = async (page, limit, filter) => {
    setLoader(true);

    try {
      const Page = page || currentPage;
      const Limit = limit || pageLimit;
      const Filter = { ...filters, ...filter };

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      let params = {
        page: Page,
        limit: Limit,
        invoice: true,
      };

      params = { ...params, ...Filter };

      const { data } = await ClientServices.getClientCostingV2(params);

      // Prepare costing data
      const shallowCopy = [];
      const clientCostArray = [];

      data?.costings?.rows.forEach((e) => {
        let val =
          parseFloat(e?.shipping_charges) +
          parseFloat(e?.late_fee) +
          parseFloat(e?.storage) +
          parseFloat(e?.category_a) +
          parseFloat(e?.broker_fee) +
          parseFloat(e?.title_fee) +
          parseFloat(e?.other_charge) +
          parseFloat(e?.custom_duty);

        let obj = {
          id: e?.id,
          shipping_charges: e?.shipping_charges,
          late_fee: e?.late_fee,
          storage: e?.storage,
          category_a: e?.category_a,
          broker_fee: e?.broker_fee,
          title_fee: e?.title_fee,
          other_charge: e?.other_charge,
          custom_duty: e?.custom_duty,
          balance:
            parseFloat(e?.invoice?.shipping_total) -
            parseFloat(e?.invoice?.shipping_paid),
          vat: e?.vat,
          amount: val.toFixed(2),
        };

        let copyClientCost = {
          costing_id: e?.id,
          shipping_charges: e?.shipping_charges,
          late_fee: e?.late_fee,
          storage: e?.storage,
          category_a: e?.category_a,
          broker_fee: e?.broker_fee,
          title_fee: e?.title_fee,
          other_charge: e?.other_charge,
          custom_duty: e?.custom_duty,
          balance:
            parseFloat(e?.invoice?.shipping_total) -
            parseFloat(e?.invoice?.shipping_paid),
          vat: e?.vat,
        };

        shallowCopy.push(obj);
        clientCostArray.push(copyClientCost);
      });

      reset();
      setTotalAmount(shallowCopy);
      setCopyClientCosting(clientCostArray);

      const newCostings = data?.costings?.rows || [];

      // ✅ Main Fix: Replace or append based on page
      if (Page === 1 || Object.keys(filter || {}).length > 0) {
        // Fresh search or filter: Replace
        setClientCosting(newCostings);
      } else {
        // Pagination: Append uniquely
        setClientCosting((prevClientCosting) => {
          const uniqueCosting = Array.from(
            new Map(
              [...prevClientCosting, ...newCostings].map((item) => [
                item.id,
                item,
              ]),
            ).values(),
          );
          return uniqueCosting;
        });
      }

      setTotalCount(data?.costings?.count);
      getVaultCustomers();
    } catch (error) {
      console.log(error, "err");
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  // const getClientCosting = async (page, limit, filter) => {
  //   setLoader(true);

  //   try {
  //     const Page = page ? page : currentPage;
  //     const Limit = limit ? limit : pageLimit;
  //     const Filter = { ...filters, ...filter };
  //     setCurrentPage(Page);
  //     setPageLimit(Limit);
  //     setFilters(Filter);
  //     let params = {
  //       page: Page,
  //       limit: Limit,
  //       invoice: true,
  //     };
  //     params = { ...params, ...Filter };
  //     const { data } = await ClientServices.getClientCosting(params);

  //     let totalShippingCharges = 0;
  //     let totalLateFee = 0;
  //     let totalStorage = 0;
  //     let totalCategoryA = 0;
  //     let totalBrokerFee = 0;
  //     let totalTitleFee = 0;
  //     let totalOtherCharges = 0;
  //     let totalCustomDuty = 0;
  //     let totalVAT5Percent = 0;
  //     let totalReceivingAmount = 0;
  //     let totalCosting = 0;
  //     let totalCusVat = 0;
  //     let totalShipping = 0;
  //     let totalNetDue = 0;
  //     let subtotal = 0;
  //     let total = 0;
  //     let balance = 0;
  //     let paid_cv = 0;
  //     let totalDiscount = 0;
  //     let customer_id = '';
  //     // Iterate through the array and accumulate the shipping charges
  //     // if (data?.costings?.rows?.length == 0) {
  //     //   ErrorToaster('This Invoice Is Already Paid!');
  //     // }
  //     // let allData = data?.costings?.rows.forEach((item) => {

  //     //   const totalShip = parseFloat(item?.invoice?.shipping_total || 0);
  //     //   const paidShip = item?.invoice?.payment?.reduce((sum, p) => sum + (parseFloat(p?.shipping_amount) || 0), 0);
  //     //   totalCosting += Math.max(totalShip - paidShip, 0);

  //     //   // totalCosting += parseFloat(item?.invoice?.shipping_total || 0);

  //     //   totalDiscount = + parseFloat(item?.discount).toFixed(2);
  //     //   if (item?.vehicle?.vcc?.custom_due) {
  //     //     const totalCustom = parseFloat(item?.invoice?.custom_total || 0);
  //     //     const paidCustom = item?.invoice?.payment?.reduce((sum, p) => sum + (parseFloat(p?.custom_amount) || 0), 0);
  //     //     totalCustomDuty += Math.max(totalCustom - paidCustom, 0);
  //     //   }

  //     //   if (item?.vehicle?.vcc?.vat_due) {
  //     //     const totalVat = parseFloat(item?.invoice?.vat_total || 0);
  //     //     const paidVat = item?.invoice?.payment?.reduce((sum, p) => sum + (parseFloat(p?.vat_amount) || 0), 0);
  //     //     totalVAT5Percent += Math.max(totalVat - paidVat, 0);
  //     //   }

  //     //   totalShipping += parseFloat(item?.total).toFixed(2);
  //     //   balance +=
  //     //     parseFloat(item?.invoice?.shipping_total) -
  //     //     parseFloat(item?.invoice?.shipping_paid);
  //     //   total += parseFloat(item?.invoice?.shipping_total).toFixed(2);
  //     //   if (!item?.vehicle?.vcc?.custom_due && !item?.vehicle?.vcc?.vat_due) {
  //     //     paid_cv += parseFloat(item?.invoice?.custom_vat_total).toFixed(2);
  //     //   }
  //     //   customer_id = item?.booking?.customer_id;
  //     // });

  //     // // setCustomerId(customer_id);
  //     // const obj = [
  //     //   { value: totalCosting || 0, flag: true },
  //     //   { value: totalCustomDuty || 0, flag: true },
  //     //   { value: totalVAT5Percent || 0, flag: true },
  //     //   { value: totalShipping || 0, flag: true },
  //     //   // { value: subtotal || 0, flag: true },
  //     //   // { value: null || 0, flag: false },
  //     //   // { value: null || 0, flag: false },

  //     // ];
  //     // setAllSums(obj);

  //     const shallowCopy = [];
  //     const clientCostArray = [];

  //     data?.costings?.rows.forEach((e) => {
  //       let val =
  //         parseFloat(e?.shipping_charges) +
  //         parseFloat(e?.late_fee) +
  //         parseFloat(e?.storage) +
  //         parseFloat(e?.category_a) +
  //         parseFloat(e?.broker_fee) +
  //         parseFloat(e?.title_fee) +
  //         parseFloat(e?.other_charge) +
  //         parseFloat(e?.custom_duty);
  //       let copyClientCost = {
  //         costing_id: e?.id,
  //       };
  //       let obj = {
  //         id: e?.id,
  //         shipping_charges: e?.shipping_charges,
  //         late_fee: e?.late_fee,
  //         storage: e?.storage,
  //         category_a: e?.category_a,
  //         broker_fee: e?.broker_fee,
  //         title_fee: e?.title_fee,
  //         other_charge: e?.other_charge,
  //         custom_duty: e?.custom_duty,
  //         balance:
  //           parseFloat(e?.invoice?.shipping_total) -
  //           parseFloat(e?.invoice?.shipping_paid),
  //         vat: e?.vat,
  //       };

  //       obj.amount = val.toFixed(2);

  //       if (true) {
  //         copyClientCost.shipping_charges = e?.shipping_charges;
  //         copyClientCost.late_fee = e?.late_fee;
  //         copyClientCost.storage = e?.storage;
  //         copyClientCost.category_a = e?.category_a;
  //         copyClientCost.broker_fee = e?.broker_fee;
  //         copyClientCost.title_fee = e?.title_fee;
  //         copyClientCost.other_charge = e?.other_charge;
  //         copyClientCost.custom_duty = e?.custom_duty;
  //         copyClientCost.balance =
  //           parseFloat(e?.invoice?.shipping_total) -
  //           parseFloat(e?.invoice?.shipping_paid);
  //         copyClientCost.vat = e?.vat;
  //       }

  //       shallowCopy.push(obj);
  //       clientCostArray.push(copyClientCost);
  //     });
  //     reset();
  //     setTotalAmount(shallowCopy);

  //     setCopyClientCosting(clientCostArray);

  //     // setClientCosting(data?.costings?.rows);
  //     setClientCosting((prevClientCosting) => {
  //       const newCostings = data?.costings?.rows || [];
  //       const uniqueCosting = Array.from(
  //         new Map([...prevClientCosting, ...newCostings].map((item) => [item.id, item])).values()
  //       );

  //       return uniqueCosting;
  //     });
  //     // setClientCosting((prevClientCosting) => [...prevClientCosting, ...data?.costings?.rows]);
  //     setTotalCount(data?.costings?.count);
  //     getVaultCustomers();
  //   } catch (error) {
  //     console.log(error, 'err');
  //     ErrorToaster(error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  // *For Apply Filters
  const applyFilter = async (value) => {
    try {
      let data = {
        customer_id: selectedClient?.id,
        search: getValues("search"),
        // vin: selectedVin?.id,
        // lot: selectedLot?.id,
        container: getValues("container"),
      };

      getClientCosting(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleCalc2 = (e) => {
    const totalReceivingUSD = selectedClientBooking.reduce((sum, id) => {
      const shipping = parseFloat(receiveShippingMap[id]) || 0;
      const custom = parseFloat(receiveCustomMap[id]) || 0;
      const vat = parseFloat(receiveVatMap[id]) || 0;
      return sum + shipping + custom + vat;
    }, 0);

    const totalAed = totalReceivingUSD * currencyExchangeRate; // Ensure this is recalculated every time
    const currentExchangeRate = parseFloat(getValues2("exChangeRate")); // Get the updated exchange rate
    const calculatedLoss = parseFloat(
      (currentExchangeRate * totalReceivingUSD - totalAed).toFixed(2), // Calculate loss
    );

    let loss;
    if (calculatedLoss === 0) {
      loss = 0;
    } else if (currentExchangeRate < currencyExchangeRate) {
      loss = Math.abs(calculatedLoss);
    } else {
      loss = -Math.abs(calculatedLoss);
    }

    setLoss(loss); // Update state for loss
    setValue("exChangeLoss", loss); // Make sure this updates the value shown in the input field
  };

  const convertToNumber = (input, decimal = 6) =>
    isNaN(Number(input)) ? 0 : Number(Number(input).toFixed(decimal));
  // *For Update client Costing
  const updateClientCosting = async (formData) => {
    setButtonState(false);
    if (selectedPaymentMethod === null) {
      ErrorToaster("Please select Payment metod");
      return;
    }
    if (sendDetails?.length === 0) {
      ErrorToaster("Please select data");
      return;
    }
    const transformedData = sendDetails.map((item) => {
      let applyCustom = false;
      let applyVat = false;

      if (
        convertToNumber(item.applied_amount) -
          convertToNumber(item.custom_duty) -
          convertToNumber(item.vat) >
        0
      ) {
        applyCustom = true;
        applyVat = true;
      } else if (
        convertToNumber(item.applied_amount) -
          convertToNumber(item.custom_duty) >
        0
      ) {
        applyCustom = true;
      }
      let comments = "";
      if (applyCustom && item?.vehicle?.vcc?.custom_due) {
        comments += `Custom Duty Amount ${item?.custom_duty} & `;
      }
      if (applyVat && item?.vehicle?.vcc?.vat_due) {
        comments += `VAT Amount ${item?.vat} `;
      }
      // if(applyCustom && applyVat){
      //   comments += `Custom Duty Amount ${item?.custom_duty} & VAT Amount ${item?.vat} `
      // }
      return {
        applied_amount: item?.applied_amount,
        paid: item?.invoice.paid
          ? parseFloat(item?.invoice.paid) + parseFloat(item?.applied_amount)
          : parseFloat(item?.applied_amount),
        balance: parseFloat(item?.invoice.balance).toFixed(2),
        costing_id: item?.invoice.costing_id,
        invoice_id: item?.invoice.id,
        container_no: item?.vehicle.container_no,
        vehicle_make: item?.booking.veh_make.name,
        vehicle_model: item?.booking.veh_model.name,
        vin: item?.booking.vin,
        booking_id: item?.booking?.id,
        lot_number: item?.booking.lot_number,
        color: item?.booking.color,
        customer_id: item?.booking?.customer?.id,
        customer_phone: item?.booking?.customer?.uae_phone,
        custom_duty: item?.vehicle?.vcc?.custom_due ? item?.custom_duty : 0,
        vat: item?.vehicle?.vcc?.vat_due ? item?.vat : 0,
        vcc_id: item?.vehicle?.vcc?.id,
        account_name: selectedBankAccount?.name,
        account_id:
          selectedBankAccount?.id ||
          selectedCashierAccount?.id ||
          selectedVaultAccount?.id,
        payment_medium: selectedPaymentMethod?.id,
        comment: getValues("comment"),
        currency: paymentType,
        shipping_amount: parseFloat(receiveShippingMap[item.id]) || 0,
        custom_amount: parseFloat(receiveCustomMap[item.id]) || 0,
        vat_amount: parseFloat(receiveVatMap[item.id]) || 0,
      };
    });

    const uniqueTransformedData = transformedData.reduce(
      (acc, item) => {
        if (!acc.idSet.has(item.invoice_id)) {
          acc.idSet.add(item.invoice_id);
          acc.result.push(item);
        }
        return acc;
      },
      { result: [], idSet: new Set() },
    ).result;

    const totalReceivingUSD = selectedClientBooking.reduce((sum, id) => {
      const shipping = parseFloat(receiveShippingMap[id]) || 0;
      const custom = parseFloat(receiveCustomMap[id]) || 0;
      const vat = parseFloat(receiveVatMap[id]) || 0;
      return sum + shipping + custom + vat;
    }, 0);

    setLoading(true);
    try {
      let obj = {
        customer_id: selectedClient?.id || customerId,
        ex_rate: getValues2("exChangeRate") || 3.675,
        ex_loss: loss || 0,
        details: uniqueTransformedData,
        type: selectedPaymentMethod?.id,
        date: date,
        comment: getValues("comment"),
        currency: paymentType,
      };
      if (selectedPaymentMethod?.id === "bank") {
        obj.bank_id = selectedBankAccount?.id;
        obj.bank_name = selectedBankAccount?.name;
        obj.payment_account = selectedBankAccount?.id;
        obj.bank_amount = parseFloat(totalReceivingUSD).toFixed(2);
      }
      if (selectedPaymentMethod?.id === "cash") {
        obj.cash_account = selectedCashierAccount?.id;
        obj.account_name = selectedCashierAccount?.name;
        obj.cash_amount = parseFloat(totalReceivingUSD).toFixed(2);
      }
      if (selectedPaymentMethod?.id === "vault") {
        // obj.payment_account = selectedVaultAccount?.id;
        // obj.account_name = selectedVaultAccount?.name;
        obj.vault_account_id = walletId;
        obj.vault_amount = parseFloat(totalReceivingUSD).toFixed(2);
      }
      const paymentRes = await ClientServices.updateFundsApplyV2(obj);
      if (paymentRes?.status === true && paymentRes?.responseCode === 200) {
        const invoice_ids = obj.details.map((p) => p.invoice_id).join(",");

        const params = { invoice_ids };

        // 1) Fetch full invoice list
        const all_invoices = await ClientServices.getClientInvoiceList(params);
        const invoices = all_invoices?.data?.details || [];

        if (!invoices.length) {
          console.log("No invoices found to upload");
          return;
        }

        // 2) Generate PDFs
        const uploadFiles = [];

        for (const inv of invoices) {
          const file = await new Promise((resolve, reject) => {
            try {
              const container = document.createElement("div");
              container.style.position = "absolute";
              container.style.top = "-99999px";
              container.style.left = "-99999px";
              container.style.width = "1200px";
              document.body.appendChild(container);

              const root = createRoot(container);

              const handleDone = (pdfBlob) => {
                setTimeout(() => {
                  try {
                    root.unmount();
                    container.remove();
                  } catch {}
                  resolve(pdfBlob);
                }, 200);
              };

              root.render(
                <ExportShippingInvoiceV2
                  invoiceDetail={inv}
                  onDone={handleDone}
                />,
              );
            } catch (err) {
              console.error("❌ PDF Generation Error", err);
              reject(err);
            }
          });

          const pdfFile =
            file instanceof Blob
              ? new File([file], `ShippingInvoiceV2-${inv?.booking?.vin}.pdf`, {
                  type: "application/pdf",
                })
              : null;

          uploadFiles.push({
            invoice_id: inv.id,
            file: pdfFile,
          });
        }

        // 3) Upload PDFs
        const formData = new FormData();
        formData.append("invoice_type", "shippingInvoicesV2");

        uploadFiles.forEach((file, index) => {
          formData.append(
            `shipping_data[${index}][invoice_id]`,
            file.invoice_id,
          );
          formData.append(`shipping_data[${index}][file]`, file.file);
        });

        await SystemServices.uploadERPInvoices(formData);

        setLoading(false);
        SuccessToaster(paymentRes.message);
        navigate("/unpaid-paid-invoices-v2");
      } else {
        setLoading(false);
        ErrorToaster(paymentRes?.message || "Payment failed");
      }
      let data = {
        container_id: selectedClient?.id,
      };
      getClientCosting(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedPaymentMethod?.id === "vault" && vaultAccounts.length > 0) {
      const defaultWallet = vaultAccounts[0];
      setSelectedVaultAccount(defaultWallet);
      setWalletId(defaultWallet?.id);
      handleSelectVault(defaultWallet);
    }
  }, [selectedPaymentMethod, vaultAccounts]);

  const renderCellContent = (colIndex, item, isActive) => {
    const totalShippingPaid = item?.invoice?.payment?.reduce(
      (total, { shipping_amount }) =>
        total + convertToNumber(shipping_amount || 0),
      0,
    );
    const totalCustomPaid = item?.invoice?.payment?.reduce(
      (total, { custom_amount }) => total + convertToNumber(custom_amount || 0),
      0,
    );
    const totalVatPaid = item?.invoice?.payment?.reduce(
      (total, { vat_amount }) => total + convertToNumber(vat_amount || 0),
      0,
    );
    const remainingCustom = convertToNumber(
      item?.invoice?.custom_total || 0 - totalCustomPaid || 0,
      2,
    );
    const remainingVat = convertToNumber(
      item?.invoice?.vat_total || 0 - totalVatPaid || 0,
      2,
    );
    const remainingShipping = convertToNumber(
      item?.invoice?.shipping_total || 0 - totalShippingPaid || 0,
      2,
    );
    const totalCustomPaidUSD = parseFloat(
      totalCustomPaid / currencyExchangeRate,
    ).toFixed(2);
    const totalVatPaidUSD = parseFloat(
      totalVatPaid / currencyExchangeRate,
    ).toFixed(2);
    const sumCustomVat = parseFloat(totalCustomPaid) + parseFloat(totalVatPaid);
    const totalCustomSHip = parseFloat(item?.invoice?.custom_total) || 0;
    const totalVatShip = parseFloat(item?.invoice?.vat_total) || 0;
    const total = parseFloat(item?.invoice?.shipping_total) || 0;

    // Sum of total, custom, and vat
    const totalShippingDue = total + totalCustomSHip + totalVatShip;

    switch (colIndex) {
      case 0:
        return (
          <Checkbox
            checked={isActive} // Check if the current item is in the selected list
            onChange={() => handleSelectClientBooking(item, item?.id)}
          />
        );
      case 1:
        const customerName = item?.booking?.customer?.name ?? "-";
        const shouldWrap = customerName.length > 19;

        return (
          <Box
            sx={{
              whiteSpace: shouldWrap ? "normal" : "nowrap",
              wordBreak: shouldWrap ? "break-word" : "unset",
              maxWidth: "200px",
              mx: "auto",
            }}
          >
            {customerName}
          </Box>
        );
      case 2:
        return " GSI-" + (item?.invoice !== null ? item?.invoice?.id : "-");
      case 3:
        return item?.booking?.purchase_date
          ? moment(item?.booking?.purchase_date).format("DD-MMM-YYYY")
          : ("-" ?? "-");

      case 4:
        const make = item?.booking?.veh_make?.name ?? "";
        const model = item?.booking?.veh_model?.name ?? "";
        const color = item?.booking.color ?? "";
        const MakeModelColor = `${make} - ${model}-${color}`;
        const shouldWrapp = MakeModelColor.length > 19;

        return (
          <Box
            sx={{
              whiteSpace: shouldWrapp ? "normal" : "nowrap",
              wordBreak: shouldWrapp ? "break-word" : "unset",
              maxWidth: "200px",
              mx: "auto",
            }}
          >
            {make && model && color
              ? MakeModelColor
              : make || model || color || "-"}
          </Box>
        );
      // const make = item?.booking?.veh_make?.name ?? "";
      // const model = item?.booking?.veh_model?.name ?? "";
      // const color = item?.booking.color ?? "";
      // return make && model && color ? `${make} - ${model}-${color}` : make || model || color || "-";
      case 5:
        return item?.booking?.lot_number ?? "-";
      case 6:
        return item?.booking?.vin ?? "-";
      case 7:
        return item?.vehicle?.arrived_port_date
          ? moment(item?.vehicle?.arrived_port_date).format("DD-MMM-YYYY")
          : "-";

      case 8:
        return CommaSeparator(parseFloat(item?.total_v2).toFixed(2)) ?? "-";

      case 9:
        return (
          CommaSeparator(parseFloat(item?.invoice?.custom_total).toFixed(2)) ??
          "-"
        );

      case 10:
        return (
          CommaSeparator(parseFloat(item?.invoice?.vat_total).toFixed(2)) ?? "-"
        );

      case 11:
        return CommaSeparator(parseFloat(totalShippingDue).toFixed(2)) ?? "-";
      case 12:
        return isActive ? (
          <InputField
            size={"small"}
            type={"number"}
            value={receiveShippingMap[item.id] || ""}
            onInput={(e) => {
              const value = parseFloat(e.target.value);
              setReceiveShippingMap((prev) => ({
                ...prev,
                [item.id]: value > defaultShipping ? defaultShipping : value,
              }));
              if (value > defaultShipping) {
                ErrorToaster(`Max allowed is ${defaultShipping}`);
              }
            }}
            disabled={defaultShipping[item?.id] <= 0}
          />
        ) : (
          (0.0 ?? " // -")
        );

      case 13:
        return isActive ? (
          <InputField
            size={"small"}
            type={"number"}
            value={receiveCustomMap[item.id] || ""}
            onInput={(e) => {
              const value = parseFloat(e.target.value);
              setReceiveCustomMap((prev) => ({
                ...prev,
                [item.id]: value > defaultCustomDue ? defaultCustomDue : value,
              }));
              if (value > defaultCustomDue) {
                ErrorToaster(`Max allowed is ${defaultCustomDue}`);
              }
            }}
            disabled={defaultCustomDue[item?.id] <= 0}
          />
        ) : (
          (0.0 ?? " // -")
        );

      case 14:
        return isActive ? (
          <InputField
            size={"small"}
            type={"number"}
            value={receiveVatMap[item.id] || ""}
            onInput={(e) => {
              const value = parseFloat(e.target.value);
              setReceiveVatMap((prev) => ({
                ...prev,
                [item.id]: value > defaultVatDue ? defaultVatDue : value,
              }));
              if (value > defaultVatDue) {
                ErrorToaster(`Max allowed is ${defaultVatDue}`);
              }
            }}
            disabled={defaultVatDue[item?.id] <= 0}
          />
        ) : (
          (0.0 ?? " // -")
        );

      case 15:
        return CommaSeparator(
          parseFloat(item?.invoice?.shipping_paid).toFixed(2),
        );

      case 16:
        return CommaSeparator(
          parseFloat(item?.invoice?.balance || 0).toFixed(2),
        );

      case 17:
        return (
          <Box
            sx={{
              path: {
                fill:
                  item?.invoice?.balance == "0.000"
                    ? Colors.primary
                    : item?.invoice?.paid == "0.000"
                      ? Colors.danger
                      : Colors.bluishCyan,
              },
            }}
          >
            <span className="pdf-hide">
              {" "}
              {parseFloat(item?.invoice?.balance) < 0.95 ? (
                <CheckIcon />
              ) : item?.invoice?.paid === "0.000" ? (
                <PendingIcon />
              ) : (
                <CheckIcon />
              )}
            </span>
            <Typography variant="body2">
              {parseFloat(item?.invoice?.balance) < 0.95
                ? "Paid"
                : parseFloat(item?.invoice?.paid) === 0
                  ? "UnPaid"
                  : "Partial"}
            </Typography>
          </Box>
        );

      default:
        return "-";
    }
  };

  const downloadExcel = async () => {
    const headers = tableHead.filter(
      (item) => item !== "Checkbox" && item !== "Action",
    );
    const rows = clientCosting?.map((item) => [
      " GSI-" + item?.invoice?.id ?? "-",
      item?.booking?.purchase_date
        ? moment(item?.booking?.purchase_date).format("DD-MMM-YYYY")
        : ("-" ?? "-"),
      item?.booking?.veh_model?.name ?? "-",
      item?.booking?.veh_make?.name ?? "-",
      item?.booking?.lot_number ?? "-",
      item?.booking?.vin ?? "-",
      item?.booking?.color ?? "-",
      item?.vehicle?.arrived_port_date
        ? moment(item?.vehicle?.arrived_port_date).format("DD-MMM-YYYY")
        : "-",
      parseFloat(item?.shipping_charges).toFixed(2) ?? "-",
      parseFloat(item?.late_fee).toFixed(2) ?? "-",
      parseFloat(item?.storage).toFixed(2) ?? "-",
      parseFloat(item?.category_a).toFixed(2) ?? "-",
      parseFloat(item?.broker_fee).toFixed(2) ?? "-",
      parseFloat(item?.title_fee).toFixed(2) ?? "-",
      parseFloat(item?.other_charge).toFixed(2) ?? "-",
      parseFloat(item?.shipping_charges) +
        parseFloat(item?.late_fee) +
        parseFloat(item?.storage) +
        parseFloat(item?.category_a) +
        parseFloat(item?.broker_fee) +
        parseFloat(item?.title_fee) +
        parseFloat(item?.other_charge) ?? "-",
      item?.invoice?.paid == 0
        ? "Unpaid"
        : item?.invoice?.paid > 0 && item?.invoice?.paid < item?.invoice?.total
          ? "Partial"
          : "Paid",
      parseFloat(item?.discount).toFixed(2) ?? "-",
      parseFloat(item?.invoice.shipping_total).toFixed(2) ?? "-",
      0.0 ?? "-",
      `USD ${parseFloat(item?.invoice?.shipping_paid).toFixed(2)}`,
      `USD ${
        balances[item?.id] ??
        parseFloat(item?.invoice?.shipping_total) -
          parseFloat(item?.invoice?.shipping_paid)
      }`,
    ]);

    let sum = [];
    allSums?.forEach((item, i) => {
      sum.push(item.flag == true ? parseFloat(item.value).toFixed(2) : "");
    });
    const totalRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total",
      ...sum,
      totalPayment ? totalPayment : 0,
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.addRow(headers);
    rows.forEach((r) => worksheet.addRow(r));
    worksheet.addRow(totalRow);

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "data.xlsx");
  };

  const totalReceivingUSD = selectedClientBooking.reduce((sum, id) => {
    const shipping = parseFloat(receiveShippingMap[id]) || 0;
    const custom = parseFloat(receiveCustomMap[id]) || 0;

    const vat = parseFloat(receiveVatMap[id]) || 0;

    return sum + shipping + custom + vat;
  }, 0);

  const totalReceivingAED = totalReceivingUSD * currencyExchangeRate;

  useEffect(() => {
    if (paymentType) {
      const cashierDetail = cashierAccounts.find(
        (e) => e.currency === paymentType,
      );
      setValue("cash", cashierDetail?.name);
      setSelectedCashierAccount(cashierDetail);
    }
  }, [paymentType]);

  useEffect(() => {
    // const getInitialClientCosting = async () => {
    //   const { data } = await ClientServices.getClientCosting();
    //   setClientCosting(data?.costings?.rows);
    //   setCopyClientCosting(data?.costings?.rows);
    // };
    // getInitialClientCosting();

    getClientDropdown();
    getVin();
    getPaymentAccounts();
    getCurrencies();
    getBanks();
  }, []);

  console.log(selectedClientBooking, "selectedClientBooking");
  return (
    <Fragment>
      <CostingDialog
        open={costingDialogOpen}
        readOnly={true}
        onClose={() => {
          setSelectedClientBooking([]);
          setSelectedContainer(null);
          setCostingDialogOpen(false);
        }}
        containerData={{ container_no: selectedContainer }}
        costings={selectedVehicles}
        currencyExchangeRate={currencyExchangeRate}
        navigate={navigate}
        selectedClient={selectedClient}
        setSelectedClientBooking={setSelectedClientBooking}
        findDifferences={findDifferences}
        getClientCosting={getClientCosting}
        copyClientCosting={copyClientCosting}
        selectedClientBooking={selectedClientBooking}
        handleCalc={handleCalc}
        updateClientCosting={updateClientCosting}
        savedData={savedData}
        setSavedData={setSavedData}
        setSelectedContainer={setSelectedContainer}
      />
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Rcv-Apply ShippingV2
            </Typography>
            {clientCosting?.length > 0 && (
              <PrimaryButton
                title={"Download Excel"}
                onClick={() => downloadExcel()}
              />
            )}
          </Box>
        </Grid>

        <Grid item md={11}>
          <Box
            sx={{
              m: "10px 0 10px 0",
              // p: '20px',
              // bgcolor: Colors.feta,
              // border: `1px solid ${Colors.iron}`,
              // borderRadius: '9px',
            }}
          >
            <Grid
              container
              spacing={1}
              alignItems={"center"}
              component={"form"}
              onSubmit={handleSubmit(applyFilter)}
            >
              <Grid item xs={12} md={3}>
                <InputField
                  size={"small"}
                  // inputStyle={{ backgroundColor: '#f5f5f5' }}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search", {
                    // onChange: (e) => applyFilter(e?.target?.value)
                  })}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <SelectField
                  size="small"
                  label={"Client"}
                  options={clients}
                  selected={selectedClient}
                  error={errors?.client?.message}
                  onSelect={(value) => {
                    setSelectedClient(value);
                  }}
                  register={register("client", {
                    // required: "Please select client.",
                  })}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    mt: "12px",
                  }}
                >
                  <PrimaryButton
                    // disabled={
                    //   !(
                    //     selectedClient?.id ||
                    //     watch('search') ||
                    //     watch('container')
                    //   )
                    // }
                    type="submit"
                    title="Search"
                  />
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}
              >
                {clientCosting.length > 0 && (
                  <FormControl size="small">
                    <InputLabel>Columns</InputLabel>
                    <Select
                      multiple
                      label="Columns"
                      value={visibleColumns}
                      onChange={handleColumnChange}
                      renderValue={() => "Show/Hide"}
                      sx={{ borderRadius: "12px !important" }}
                    >
                      {tableHead.map((column, index) => {
                        if (
                          column !== "Checkbox" &&
                          column !== "Arrived Date" &&
                          column !== "SHIPPING CHARGE" &&
                          column !== "LATE FEE" &&
                          column !== "STORAGE" &&
                          column !== "CATEGORY A" &&
                          column !== "BROKER FEE" &&
                          column !== "TITLE FEE" &&
                          column !== "OTHER CHARGE" &&
                          column !== "CUSTOM DUTY" &&
                          column !== "VAT" &&
                          column !== "TOTAL" &&
                          column !== "Discount" &&
                          column !== "Net Due" &&
                          column !== "Receiving Amount" &&
                          column !== "Applied Status" &&
                          column !== "Paid" &&
                          column !== "Balance"
                        ) {
                          return (
                            <MenuItem key={index} value={index}>
                              <Checkbox
                                checked={visibleColumns.includes(index)}
                              />
                              <ListItemText primary={column} />
                            </MenuItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item md={11}>
          <Box>
            {clientCosting.length > 0 && (
              <TableContainer
                // component={Paper}
                sx={{
                  // boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                  borderRadius: 2,
                  maxWidth: "calc(100vw - 330px)",
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                <Table stickyHeader sx={{ minWidth: 500 }}>
                  <TableHead>
                    <TableRow>
                      {visibleColumns.map((index) => (
                        <Cell
                          className="pdf-table"
                          key={index}
                          sx={{
                            maxWidth:
                              tableHead[index].length > 10 ? "200px" : "auto",
                          }}
                        >
                          {tableHead[index] === "Checkbox" ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Checkbox
                                className="pdf-hide"
                                sx={{ color: "white !important" }}
                                checked={selectAll}
                                onChange={() => handleAllCheck(!selectAll)}
                              />
                              <span>All</span>
                            </div>
                          ) : (
                            tableHead[index]
                          )}
                        </Cell>
                        // <Cell
                        //   key={index}
                        //   sx={{
                        //     bgcolor: `${index < 9 ? Colors.primary : Colors.blue
                        //       } !important`,
                        //   }}
                        // >
                        //   {tableHead[index]}
                        // </Cell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {!loader ? (
                      clientCosting?.length > 0 ? (
                        <Fragment>
                          {clientCosting?.map((item, rowIndex) => {
                            const isActive =
                              selectedClientBooking.indexOf(item?.id) !== -1;
                            const isSelected = selectedClientBooking.includes(
                              item.id,
                            );
                            const totalShippingAmount = Object.values(
                              receiveShippingMap,
                            ).reduce(
                              (sum, val) => sum + (parseFloat(val) || 0),
                              0,
                            );
                            const totalCustomAmount = Object.values(
                              receiveCustomMap,
                            ).reduce(
                              (sum, val) => sum + (parseFloat(val) || 0),
                              0,
                            );
                            const totalVatAmount = Object.values(
                              receiveVatMap,
                            ).reduce(
                              (sum, val) => sum + (parseFloat(val) || 0),
                              0,
                            );

                            return (
                              <Row
                                key={rowIndex}
                                sx={{
                                  bgcolor: rowIndex % 2 !== 0 && "#EFF8E7",
                                }}
                              >
                                {visibleColumns.map((colIndex) => (
                                  <Cell
                                    key={colIndex}
                                    onDoubleClick={() => {
                                      if (isActive) {
                                        setSelectedVehicles(
                                          clientCosting.filter((c) =>
                                            selectedClientBooking.includes(
                                              c.id,
                                            ),
                                          ),
                                        );
                                        setSelectedContainer(
                                          item?.vehicle?.container_no,
                                        );
                                        setCostingDialogOpen(true);
                                      }
                                    }}
                                  >
                                    {renderCellContent(
                                      colIndex,
                                      item,
                                      isActive,
                                    )}
                                  </Cell>
                                ))}
                              </Row>
                            );
                          })}
                        </Fragment>
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={visibleColumns.length + 1}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            No Data Found
                          </TableCell>
                        </TableRow>
                      )
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={visibleColumns.length + 2}
                          align="center"
                          sx={{ fontWeight: 600 }}
                        >
                          <Box className={classes.loaderWrap}>
                            <CircularProgress />
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                    <Row sx={{ bgcolor: "#EEFBEE", p: "10px" }}>
                      {[...Array(visibleColumns?.length - 11)].map(
                        (_, index) => (
                          <Cell key={index} />
                        ),
                      )}
                      <Cell>
                        <Box
                          sx={{
                            // bgcolor: '#747474',
                            // border: '1px solid #747474',
                            p: "10px 20px",
                            textAlign: "center",
                            color: Colors.black,
                          }}
                        >
                          Total Due $
                        </Box>
                      </Cell>
                      {allSums &&
                        allSums.length > 0 &&
                        allSums.map((item, index) => {
                          return (
                            <Cell key={index}>
                              {item.flag && (
                                <Box
                                  sx={{
                                    bgcolor: "#E3E3E3",
                                    border: "1px solid #747474",
                                    p: "10px 20px",
                                    textAlign: "center",
                                  }}
                                >
                                  {CommaSeparator(
                                    parseFloat(item.value).toFixed(2),
                                  )}
                                </Box>
                              )}
                            </Cell>
                          );
                        })}
                      <Cell>
                        <Box
                          sx={{
                            bgcolor: "#4ab53e",
                            border: "1px solid #747474",
                            p: "10px 20px",
                            textAlign: "center",
                            color: "white",
                            fontWeight: "700",
                            fontSize: 15,
                          }}
                        >
                          ${" "}
                          {receiveShippingMap
                            ? CommaSeparator(
                                Object.values(receiveShippingMap)
                                  .reduce(
                                    (sum, val) => sum + (parseFloat(val) || 0),
                                    0,
                                  )
                                  .toFixed(2),
                              )
                            : 0}
                        </Box>
                      </Cell>
                      <Cell>
                        <Box
                          sx={{
                            bgcolor: "#4ab53e",
                            border: "1px solid #747474",
                            p: "10px 20px",
                            textAlign: "center",
                            color: "white",
                            fontWeight: "700",
                            fontSize: 15,
                          }}
                        >
                          ${" "}
                          {receiveCustomMap
                            ? CommaSeparator(
                                Object.values(receiveCustomMap)
                                  .reduce(
                                    (sum, val) => sum + (parseFloat(val) || 0),
                                    0,
                                  )
                                  .toFixed(2),
                              )
                            : 0}
                        </Box>
                      </Cell>
                      <Cell>
                        <Box
                          sx={{
                            bgcolor: "#4ab53e",
                            border: "1px solid #747474",
                            p: "10px 20px",
                            textAlign: "center",
                            color: "white",
                            fontWeight: "700",
                            fontSize: 15,
                          }}
                        >
                          ${" "}
                          {receiveVatMap
                            ? CommaSeparator(
                                Object.values(receiveVatMap)
                                  .reduce(
                                    (sum, val) => sum + (parseFloat(val) || 0),
                                    0,
                                  )
                                  .toFixed(2),
                              )
                            : 0}
                        </Box>
                      </Cell>
                    </Row>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>

          {clientCosting.length > 0 && (
            <Pagination
              currentPage={currentPage}
              pageSize={pageLimit}
              onPageSizeChange={(size) =>
                getClientCosting(1, size.target.value)
              }
              tableCount={clientCosting?.length}
              totalCount={totalCount}
              onPageChange={(page) => getClientCosting(page, "")}
            />
          )}

          {selectedClientBooking.length > 0 && (
            <>
              <Box
                sx={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  p: 5,
                  bgcolor: Colors.white,
                  borderRadius: 3,
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                }}
              >
                <Box component="form">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid item sm={4}>
                      <InputField
                        label={"Total Receiveing Amount $"}
                        value={parseFloat(totalReceivingUSD).toFixed(2)}
                        error={errors?.vendor?.message}
                        disabled={true}
                        register={register("totalReceiveAmount", {})}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <InputField
                        label={"Total Receiveing Amount AED"}
                        value={totalReceivingAED.toFixed(2)}
                        disabled={true}
                        error={errors?.vendor?.message}
                        register={register("receiveCustom", {})}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
                  </Grid>

                  <Grid container spacing={2} alignItems={"center"}>
                    {/* <Grid container alignItems={'flex-start'} spacing={1}> */}
                    <Grid item xs={12} sm={4}>
                      <DatePicker
                        disableFuture={true}
                        size="small"
                        label={"Payment Date"}
                        value={date}
                        onChange={(date) => handleFromDate(date)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <SelectField
                        size={"small"}
                        label={"Payment Method"}
                        options={[
                          ...(allowedRolesForCash.includes(user?.role_id)
                            ? [
                                {
                                  id: "cash",
                                  name: "Cash",
                                },
                              ]
                            : []),
                          {
                            id: "bank",
                            name: "Bank GWS",
                          },
                          {
                            id: "bank",
                            name: "Bank GUC",
                          },
                          {
                            id: "vault",
                            name: "Wallet",
                          },
                        ]}
                        selected={selectedPaymentMethod}
                        onSelect={(value) => setSelectedPaymentMethod(value)}
                        error={errors?.paymentMethod?.message}
                        register={register("paymentMethod", {
                          // required: 'Please select payment method.',
                        })}
                      />
                    </Grid>
                    {selectedPaymentMethod?.id === "cash" && (
                      <Fragment>
                        <Grid item xs={12} sm={4}>
                          <InputLabel>Cash in Hand</InputLabel>
                          <FormControl>
                            <RadioGroup
                              row
                              value={paymentType}
                              onChange={(e) => setPaymentType(e.target.value)}
                            >
                              <FormControlLabel
                                value="aed"
                                control={<Radio />}
                                label="AED"
                              />
                              <FormControlLabel
                                value="usd"
                                control={<Radio />}
                                label="USD"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <SelectField
                            disabled={
                              allowedRolesForCash.includes(user?.role_id)
                                ? true
                                : false
                            }
                            size={"small"}
                            label={"Cashier Account"}
                            options={cashierAccounts}
                            selected={selectedCashierAccount}
                            onSelect={(value) =>
                              setSelectedCashierAccount(value)
                            }
                            error={errors?.cash?.message}
                            register={register("cash", {
                              // required:
                              //   selectedPaymentMethod?.id === 'cash'
                              //     ? 'Please select cash account.'
                              //     : false,
                            })}
                          />
                        </Grid>
                      </Fragment>
                    )}
                    {selectedPaymentMethod?.id === "bank" ||
                    selectedPaymentMethod?.name === "Bank GUC" ? (
                      <>
                        <Grid item xs={12} sm={4}>
                          <SelectField
                            size="small"
                            label="Bank Account"
                            options={
                              selectedPaymentMethod?.name === "Bank GUC"
                                ? bankAccountsGuc.map((account) => ({
                                    id: account?.guc_account?.id,
                                    name: account?.guc_account?.name,
                                    totalBal: account?.gucBal,
                                    account_code:
                                      account?.guc_account?.account_code,
                                  }))
                                : bankAccountsGws.map((account) => ({
                                    id: account?.gwc_account?.id,
                                    name: account?.gwc_account?.name,
                                    totalBal: account?.gwcBal,
                                    account_code:
                                      account?.gwc_account?.account_code,
                                  }))
                            }
                            selected={selectedBankAccount}
                            onSelect={(value) => {
                              if (!value?.id) {
                                ErrorToaster(
                                  "DO NOT CLOSE THE TAB REPORT TO IT FOR REVIEW.",
                                );
                              } else {
                                setSelectedBankAccount(value);
                              }
                            }}
                            error={errors?.bank?.message}
                            register={register("bank", {
                              // required:
                              //   selectedPaymentMethod?.id === 'bank' || selectedPaymentMethod?.name === 'Bank GUC'
                              //     ? 'Please select bank account.'
                              //     : false,
                            })}
                          />
                        </Grid>

                        {selectedBankAccount && (
                          <Grid item xs={12} md={4}>
                            <InputField
                              label={"Bank balance "}
                              disabled={true}
                              value={parseFloat(
                                selectedBankAccount?.totalBal,
                              ).toFixed(2)}
                              size="small"
                            />
                          </Grid>
                        )}
                      </>
                    ) : null}

                    {selectedPaymentMethod?.id === "vault" && (
                      <Fragment>
                        <Grid item xs={12} sm={4}>
                          <SelectField
                            size={"small"}
                            label={"Wallet Account"}
                            options={vaultAccounts}
                            selected={selectedVaultAccount}
                            onSelect={(value) => {
                              setWalletId(value?.id);
                              handleSelectVault(value);
                            }}
                            error={errors?.vault?.message}
                            register={register("vault", {
                              // required:
                              //   selectedPaymentMethod?.id === "vault"
                              //     ? "Please select vault account."
                              //     : false,
                            })}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <InputField
                            disabled={true}
                            size={"small"}
                            label={"Wallet Balance (USD)"}
                            placeholder={"Vault Balance(USD)"}
                            value={parseFloat(walletBalance).toFixed(2)}
                            register={register("vaultBalance")}
                          />
                        </Grid>
                      </Fragment>
                    )}
                    {(selectedPaymentMethod?.id === "bank" ||
                      selectedPaymentMethod?.name === "Bank GUC" ||
                      selectedPaymentMethod?.id === "cash" ||
                      selectedPaymentMethod?.id == "vault") && (
                      <>
                        <Grid item xs={12} md={4}>
                          <InputField
                            label={"Exchange Rate "}
                            defaultValue={currencyExchangeRate}
                            size="small"
                            error={errors?.exChangeRate?.message}
                            register={register2("exChangeRate", {
                              onChange: (e) => {
                                if (e.target.value == 0) {
                                  setValue(
                                    "exChangeRate",
                                    currencyExchangeRate,
                                  );
                                } else {
                                  handleCalc2(e);
                                }
                              },
                              required: "Please Enter Exchange rate",
                            })}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <InputField
                            label={"Exchange Loss/Gain"}
                            value={loss || 0}
                            disabled={true}
                            size="small"
                            register={register2("exChangeLoss", {})}
                          />
                        </Grid>
                      </>
                    )}

                    <Grid item xs={12}>
                      <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <InputField
                        label={"Comment"}
                        multiline={true}
                        rows={2}
                        placeholder={"comment"}
                        register={register("comment")}
                        // inputStyle={{ width: '350px' }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              {clientCosting.some(
                (c) =>
                  c.shipping?.is_consignment === true &&
                  selectedClientBooking.includes(c.id),
              ) &&
                (() => {
                  const matchedContainers = [
                    ...new Set(
                      clientCosting
                        .filter(
                          (c) =>
                            c.shipping?.is_consignment === true &&
                            selectedClientBooking.includes(c.id),
                        )
                        .map((c) => c.shipping?.container_no),
                    ),
                  ];
                  const isSingle = matchedContainers.length === 1;

                  return (
                    <Typography
                      color="error"
                      variant="body2"
                      sx={{
                        mt: 1,
                        fontFamily: "Helvetica",
                        fontWeight: 700,
                        padding: "10px",
                        fontSize: "16px",
                        color: "#FE2E1B",
                      }}
                    >
                      Please do the payment for the full container.{" "}
                      {isSingle
                        ? "This is a consignment container: "
                        : "These are consignment containers: "}
                      {matchedContainers.join(", ")}
                    </Typography>
                  );
                })()}

              <Box
                sx={{
                  marginRight: "30px",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <PrimaryButton
                  type={"submit"}
                  disabled={
                    !(
                      selectedPaymentMethod?.id &&
                      (selectedPaymentMethod?.id === "bank"
                        ? selectedBankAccount?.id
                        : selectedPaymentMethod?.name === "Bank GUC"
                          ? selectedBankAccount?.id
                          : selectedPaymentMethod?.id === "cash"
                            ? selectedCashierAccount?.id
                            : selectedVaultAccount?.id)
                    )
                  }
                  onClick={handleSubmit2(updateClientCosting)}
                  // disabled={selectedPaymentMethod?.id && (selectedPaymentMethod?.id == 'bank' ? selectedBankAccount?.id : selectedPaymentMethod?.id == 'cash' ? selectedCashierAccount?.id : selectedVaultAccount?.id) ? false : true} onClick={handleSubmit2(updateClientCosting)}
                  title="Submit"
                  loading={loading}
                />
              </Box>
            </>
          )}
        </Grid>
        {/* {cashierDetails && (

          <Box component={'form'} sx={{
            my: 4, width: '100%', mx: 8
          }}>
            <Grid container alignItems={'flex-start'} spacing={1}>
              <Grid item xs={12} sm={3.3}>
                <DatePicker
                  disableFuture={true}
                  size='small'
                  label={'Payment Date'}
                  value={date}
                  onChange={(date) => handleFromDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={3.3}>
                <SelectField
                  size={'small'}
                  label={'Payment Method'}
                  options={[
                    ...(allowedRolesForCash.includes(user?.role_id)
                      ? [
                        {
                          id: "cash",
                          name: "Cash",
                        },
                      ]
                      : []),
                    {
                      id: 'bank',
                      name: 'Bank GWS',
                    },
                    {
                      id: 'bank',
                      name: 'Bank GUC',
                    },
                    {
                      id: 'vault',
                      name: 'Wallet',
                    },
                  ]}
                  selected={selectedPaymentMethod}
                  onSelect={(value) => setSelectedPaymentMethod(value)}
                  error={errors?.paymentMethod?.message}
                  register={register('paymentMethod', {
                    required: 'Please select payment method.',
                  })}
                />
              </Grid>
              {selectedPaymentMethod?.id === 'cash' && (
                <Fragment>
                  <Grid item xs={12} sm={3}>
                    <InputLabel>Cash in Hand</InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={paymentType}
                        onChange={(e) => setPaymentType(e.target.value)}
                      >
                        <FormControlLabel
                          value='aed'
                          control={<Radio />}
                          label='AED'
                        />
                        <FormControlLabel
                          value='usd'
                          control={<Radio />}
                          label='USD'
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <SelectField
                      disabled={allowedRolesForCash.includes(user?.role_id)
                        ? true : false}
                      size={'small'}
                      label={'Cashier Account'}
                      options={cashierAccounts}
                      selected={selectedCashierAccount}
                      onSelect={(value) => setSelectedCashierAccount(value)}
                      error={errors?.cash?.message}
                      register={register('cash', {
                        required:
                          selectedPaymentMethod?.id === 'cash'
                            ? 'Please select cash account.'
                            : false,
                      })}
                    />
                  </Grid>
                </Fragment>
              )}
              {selectedPaymentMethod?.id === 'bank' || selectedPaymentMethod?.name === 'Bank GUC' ? (
                <>
                  <Grid item xs={12} sm={2.8}>
                    <SelectField
                      size="small"
                      label="Bank Account"
                      options={
                        selectedPaymentMethod?.name === 'Bank GUC'
                          ? bankAccountsGuc.map((account) => ({
                            id: account?.guc_account?.id,
                            name: account?.guc_account?.name,
                            totalBal: account?.gucBal,
                            account_code: account?.guc_account?.account_code,
                          }))
                          : bankAccountsGws.map((account) => ({
                            id: account?.gwc_account?.id,
                            name: account?.gwc_account?.name,
                            totalBal: account?.gwcBal,
                            account_code: account?.gwc_account?.account_code,
                          }))
                      }
                      selected={selectedBankAccount}
                      onSelect={(value) => {
                        if (!value?.id) {
                          ErrorToaster('DO NOT CLOSE THE TAB REPORT TO IT FOR REVIEW.')
                        } else {
                          setSelectedBankAccount(value)
                        }
                      }}
                      error={errors?.bank?.message}
                      register={register('bank', {
                        required:
                          selectedPaymentMethod?.id === 'bank' || selectedPaymentMethod?.name === 'Bank GUC'
                            ? 'Please select bank account.'
                            : false,
                      })}
                    />
                  </Grid>

                  {selectedBankAccount && (
                    <Grid item xs={12} md={3}>
                      <InputField
                        label={'Bank balance '}
                        disabled={true}
                        value={parseFloat(
                          selectedBankAccount?.totalBal
                        ).toFixed(2)}
                        size='small'
                      />
                    </Grid>
                  )}
                </>
              ) : null}

              {selectedPaymentMethod?.id === 'vault' && (
                <Fragment>
                  <Grid item xs={12} sm={3}>
                    <SelectField
                      size={"small"}
                      label={"Wallet Account"}
                      options={vaultAccounts}
                      selected={selectedVaultAccount}
                      onSelect={(value) => {
                        setWalletId(value?.id)
                        handleSelectVault(value)
                      }}
                      error={errors?.vault?.message}
                      register={register("vault", {
                        required:
                          selectedPaymentMethod?.id === "vault"
                            ? "Please select vault account."
                            : false,
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <InputField
                      disabled={true}
                      size={"small"}
                      label={"Wallet Balance (USD)"}
                      placeholder={"Vault Balance(USD)"}
                      value={parseFloat(walletBalance).toFixed(2)}
                      register={register("vaultBalance")}
                    />
                  </Grid>
                </Fragment>
              )}
              {(selectedPaymentMethod?.id === 'bank' || selectedPaymentMethod?.name === 'Bank GUC' ||
                selectedPaymentMethod?.id === 'cash' || selectedPaymentMethod?.id == 'vault') && (
                  <>
                    <Grid item xs={12} md={3}>
                      <InputField
                        label={'Exchange Rate '}
                        defaultValue={currencyExchangeRate}
                        size='small'
                        error={errors?.exChangeRate?.message}
                        register={register2('exChangeRate', {
                          onChange: (e) => {
                            if (e.target.value == 0) {
                              setValue('exChangeRate', currencyExchangeRate)
                            } else {
                              handleCalc2(e)
                            }
                          },
                          required: "Please Enter Exchange rate"
                        })}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputField
                        label={'Exchange Loss/Gain'}
                        value={loss || 0}
                        disabled={true}
                        size='small'
                        register={register2('exChangeLoss', {})}
                      />
                    </Grid>
                  </>
                )}
              <Grid item xs={12} sm={12}>
                <InputField
                  label={'Comment'}
                  multiline={true}
                  rows={2}
                  placeholder={'comment'}
                  register={register('comment')}
                  inputStyle={{ width: '350px' }}
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ textAlign: 'right' }}>
                <PrimaryButton
                  type={'submit'}
                  disabled={!(selectedPaymentMethod?.id && (
                    (selectedPaymentMethod?.id === 'bank' ? selectedBankAccount?.id :
                      selectedPaymentMethod?.name === 'Bank GUC' ? selectedBankAccount?.id :
                        selectedPaymentMethod?.id === 'cash' ? selectedCashierAccount?.id :
                          selectedVaultAccount?.id)
                  ))} onClick={handleSubmit2(updateClientCosting)}
                  // disabled={selectedPaymentMethod?.id && (selectedPaymentMethod?.id == 'bank' ? selectedBankAccount?.id : selectedPaymentMethod?.id == 'cash' ? selectedCashierAccount?.id : selectedVaultAccount?.id) ? false : true} onClick={handleSubmit2(updateClientCosting)}
                  title='Update'
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Box>
        )} */}
      </Grid>
    </Fragment>
  );
}

export default ClientFundsApplicationV2;
